var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { LanguageService } from '../services/language.service';
import { NgbDateParserFormatter, NgbDate } from '@ng-bootstrap/ng-bootstrap';
var CustomNgbDateParserFormatter = /** @class */ (function (_super) {
    __extends(CustomNgbDateParserFormatter, _super);
    /**
     * Creates an instance of CustomNgbDateParserFormatter.
     * @param {LanguageService} language
     * @memberof CustomNgbDateParserFormatter
     */
    function CustomNgbDateParserFormatter(language) {
        var _this = _super.call(this) || this;
        _this.language = language;
        return _this;
    }
    /**
     * convert NgbDateStruct to Date
     *
     * @static
     * @param {NgbDateStruct} ngbDate
     * @returns {Date}
     * @memberof CustomNgbDateParserFormatter
     */
    CustomNgbDateParserFormatter.toDate = function (ngbDate) {
        return new Date(ngbDate.year, ngbDate.month - 1, ngbDate.day, 12, 0, 0);
    };
    /**
     * convert Date to NgbDateStruct
     *
     * @static
     * @param {Date} date
     * @returns {NgbDateStruct}
     * @memberof CustomNgbDateParserFormatter
     */
    CustomNgbDateParserFormatter.toNgbDate = function (date) {
        return new NgbDate(date.getFullYear(), date.getMonth() + 1, date.getDate());
    };
    /**
     * custom implementation of parse
     *
     * @param {string} value
     * @returns {NgbDateStruct}
     * @memberof CustomNgbDateParserFormatter
     */
    CustomNgbDateParserFormatter.prototype.parse = function (value) {
        var date = this.language.parseDate(value);
        return CustomNgbDateParserFormatter.toNgbDate(date);
    };
    /**
     * custom implementation of format
     *
     * @param {NgbDateStruct} date
     * @returns {string}
     * @memberof CustomNgbDateParserFormatter
     */
    CustomNgbDateParserFormatter.prototype.format = function (date) {
        return date ? this.language.formatDate(CustomNgbDateParserFormatter.toDate(date)) : '';
    };
    return CustomNgbDateParserFormatter;
}(NgbDateParserFormatter));
export { CustomNgbDateParserFormatter };
